export const environment = {
   production: true,
   utcQueryStrings: false,
   idempotentStorageKeyName: 'tyalls-idempotent-key',
   datadog: {
      enabled: true,
      applicationId: 'ac7e7511-4774-4736-aa46-b586b7ba7fd8',
      clientToken: 'pub89c36582e2ec88702f131c18ba80ca7e',
      env: 'prod'
   },
   auth: {
      domain: 'auth.tyalls.com',
      clientId: 'rK1VOuORb4bGeH5wL4t1awnFFZJnv7f0',
      audience: 'api.app.v2.tyalls.com'
   },
   apiEndpoint: 'https://api.app.v2.tyalls.com',
   dashboardReturnUrl: 'https://v2.tyalls.com/dashboard',
   PSPDFKit: {
      key: 'Ui8-Arp1M9aflVlsj5n179AVfPJOUInHQc9kZ8rJdYwKr23A6HpJbBc9hTekaa_9x5X680fafHtuKQft74TcG3SIhyVPK7K0WiZY6Qje91GVJHAdIybWejcD33jVVefKXlNgyS3amYRH3xniVEzO_zquK1EozdCwxy1RaAPivF5w52TGAkj-RVFDu4XEX_OyhSOJTA9ud15S68woUUqr1yhsCAETFpsPpn45K-P4ovMWv2i-c6sP7EF26gzp7gfVkgl6mTPETwai4UKZpMdESErxxCPtKSpWhbImYRzdlOLWTwo2_lu4-eTbC638eh3DjKbNBoeUHH5n79quoAN7IlfD7gyQ_QGQxl3P5KIk2jdCMDI5LCK9zEz7ZigN3zZZJn-idoz_vRbflwVn376GTecixxWW1iqaJ096jPrOqW0t9MlTrkCICQDH9F2VdsMojkgf-0UDkatBk4jzFjmgM0IeaB_-jCKmgXWjOSPKvPVG1Kv1LsqVyhKwj7blBIMs',
      serverUrl: 'https://pdf.app.v2.tyalls.com/',
      serverPem: `-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----`
   },
   roles: {
      accountOwner: 'rol_ZWYBvXwCgOPe4IEA'
   },
   externalLinks: {
      supportHub: 'https://tyalls.atlassian.net/servicedesk/customer/portals'
   },
   trialDays: 14,
   trialStartNoticeDay: 5,
   trialGracePeriodDays: 7,
   supportLinks: {
      billingPage: '/property/admin/billing-page',
      billingSetup: '/property/admin/billing-setup'
   },
   emails: {
      tyallsSupport: 'support@tyalls.com'
   },
   productFruit: {
      enabled: false,
      workspaceCode: 'shWAHLPw3xk81W5A',
      langCode: 'en'
   }
};
